// Racine unique du serveur d'API Prosveta (pensées, collections, livres, distributeurs,
// abonnements), utilisée côté serveur (server/dataLoaders.mjs) comme dans le navigateur. Pour
// changer de serveur d'API, c'est la seule ligne à modifier.
export const API_URL = 'https://api.prosveta.com';

// URL d'un appel à l'API : `apiUrl('distributors', { type: 'ALL' })` →
// https://api.prosveta.com/distributors?type=ALL. Les paramètres vides sont ignorés ; d'autres
// peuvent être ajoutés ensuite via `url.searchParams`.
export function apiUrl(path, params = {}) {
  const url = new URL(String(path).replace(/^\/+/, ''), `${API_URL}/`);
  for (const [key, value] of Object.entries(params)) {
    if (value !== undefined && value !== null && value !== '') {
      url.searchParams.set(key, String(value));
    }
  }
  return url;
}
